import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { catchError, filter, race, switchMap, take, throwError, timer } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {

  const configService = inject(ConfigService);
  const authService = inject(AuthService);

  if (req.url.includes('/recruitment-http/lti')) {
    return next(req);
  }

  req = setReqHeader(req, configService);

  return next(req).pipe(
    catchError((error) => {
      if (!req.url.includes('/auth') && error.status === 403 && error.error?.message === 'Forbidden') {

        const timeout$ = timer(3000).pipe(
          switchMap(() => throwError(() => new Error('Refresh token timeout'))),
        );

        const refreshToken$ = authService.refreshToken().pipe(
          filter((token) => token !== null), // Tunggu sampai token baru tersedia
          take(1),
          switchMap(() => {
            // Set token baru ke request
            req = setReqHeader(req, configService);

            // Retry request dengan token baru
            return next(req);
          }),
          catchError((err) => {
            console.error('Refresh Token Failed:', err);
            authService.logout(); // Logout jika refresh token gagal
            return throwError(() => new Error('REFRESH_TOKEN_FAILED'));
          }),
        );

        return race([refreshToken$, timeout$]);
      }
      return throwError(() => error);
    })
  );
};

function setReqHeader(req: HttpRequest<any>, configService: ConfigService): HttpRequest<any> {
  const token = configService.getToken();
  const tenantUuid = configService.getTenantUuid();

  const whitelistedUrl = [
    'http://localhost',
    'https://api.sokrates.xyz',
    'https://api.sokrates.co.id',
  ];

  if (whitelistedUrl.some((url) => req.url.includes(url))) {
    const headers = {};

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    if (req.url.includes('recruitment-http')) {
      headers['tenant-uuid'] = tenantUuid;
    }

    return req.clone({
      setHeaders: headers,
    });
  }

  return req;
}
